import { useEffectOnce } from '@paradigm/utils/src/hooks';
import { useGrfqBboService } from '#/unified-rfqs/contexts/grfq-bbo';

export default function useMarkPriceWsHandler() {
  const grfqBboService = useGrfqBboService();
  useEffectOnce(() => {
    grfqBboService.startWebSocket();

    return () => grfqBboService.close();
  });
}
